

import React, { Component } from 'react'
import { withRouter } from 'react-router'
import Snackbar from 'material-ui/Snackbar'
import { Card, CardActions, CardHeader, CardMedia, CardTitle, CardText } from 'material-ui/Card'
import FlatButton from 'material-ui/FlatButton'
import Intro from '../home/sections/intro/Intro'
import GoogleLogin from '../../components/google-login';
import TextField from 'material-ui/TextField';
import RaisedButton from 'material-ui/RaisedButton';

import './Registration.css'

class Registration extends Component {

    constructor(props) {
        super(props)
        let licenseText = "hasta 100 personas";
        if (document.licenseType) {
            switch (document.licenseType) {
                case 1: licenseText = 'hasta 100 personas'; break;
                case 2: licenseText = 'hasta 500 personas'; break;
                case 3: licenseText = 'Hasta 10 mil personas'; break;
                case 4: licenseText = 'Más de 10 mil personas'; break;
            }
        }
        this.state = {
            licenseType: licenseText
        };
    }

    componentDidMount = () => {

    }

    onLoginSuccessed = () => {
        console.log(`Exitoso!`);
    }

    onLoginFailed = () => {
        this.props.history.push(`/quotation`);
    };

    next = () => {
        document.companyName = this.companyName.getValue();
        document.patentName = this.patentName.getValue();
        document.address = this.address.getValue();
        document.email = this.email.getValue();
        document.phonenumber = this.phonenumber.getValue();
        document.licenseType = this.state.licenseType;
        this.props.history.push(`/summary`);
    };


    render() {
        return (
            <div className="registration-page">
                <div className="registration">
                    <GoogleLogin
                        ref={(googleLogin) => { this.googleLogin = googleLogin; }}
                        onSuccess={this.onLoginSuccessed}
                        onFailure={this.onLoginFailed}
                    />
                    <Intro />
                    <br />
                    <br />
                    <br />
                    <h1>Datos del Certificado de Licencia de Comunicación Pública</h1>
                    <div className="row">
                        <TextField
                            hintText="Nombre empresa"
                            floatingLabelText="Ingresar nombre comercial"
                            fullWidth={true}
                            ref={(input) => { this.companyName = input; }}
                        />
                    </div>
                    <div className="row">
                        <TextField
                            hintText="Licenciatario"
                            floatingLabelText="Ingresar nombre de la Patente de comercio"
                            fullWidth={true}
                            ref={(input) => { this.patentName = input; }}
                        />
                    </div>
                    <div className="row">
                        <TextField
                            hintText="Ubicación"
                            floatingLabelText="Ingresar la dirección donde sonará la música"
                            fullWidth={true}
                            ref={(input) => { this.address = input; }}
                        />
                    </div>
                    <div className="row">
                        <TextField
                            hintText="Correo electrónico"
                            floatingLabelText="Ingresar email de contacto"
                            fullWidth={true}
                            ref={(input) => { this.email = input; }}
                        />
                    </div>
                    <div className="row">
                        <TextField
                            hintText="Teléfono"
                            floatingLabelText="Ingresar teléfono de contacto"
                            fullWidth={true}
                            ref={(input) => { this.phonenumber = input; }}
                        />
                    </div>
                    <div className="row">
                        <TextField
                            hintText="Dimensión"
                            value={this.state.licenseType}
                            fullWidth={true}
                            readOnly={true}
                        />
                    </div>
                    <RaisedButton label="Siguiente" onClick={this.next} fullWidth={true} />
                </div>
                <div>
                    <br />
                    <br />
                    <br />
                    <br />
                    <br />
                    <br />
                    <br />
                    <br />
                    <br />
                    <br />
                    <br />
                    <br />
                    <br />
                    <section className="bottom">
                        <div className="bottom-content">
                            <span>Powered by <a className="powered-by" href="http://www.adstter.com">Adstter</a></span>
                        </div>
                    </section>
                </div>
            </div>
        )
    }
}

export default withRouter(Registration)



// WEBPACK FOOTER //
// ./src/pages/registration/Registration.js